// 初期表示（環境活動ページの表示）
export const PAGE_INIT = "corp/csr/environment/PAGE_INIT";
// 「環境報告書、CSR報告書」データ取得
export const REPORT_LOAD = "corp/csr/environment/REPORT_LOAD";
// 環境活動ページを選択された期間に更新する
export const PAGE_UPFATE = "corp/csr/environment/PAGE_UPFATE";
// 期間変更
export const ENVIRONMENT_PERIOD_CHANGE =
  "corp/csr/environment/ENVIRONMENT_PERIOD_CHANGE";
